import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FiltersDropdown } from '@shared/components/ui/FiltersDropdown';
import { CustomerFiltersPanel } from './CustomerFiltersPanel';

interface CustomerFiltersProps {
  ordersMinMonth: number | null;
  ordersMaxMonth: number | null;
  saleType: 'cod' | 'card' | null;
  countryId: number | null;
  customerOrigins: string[];
  updateFilters: (filters: {
    ordersMinMonth?: number | null;
    ordersMaxMonth?: number | null;
    saleType?: 'cod' | 'card' | null;
    countryId?: number | null;
    customerOrigins?: string[];
  }) => void;
  onClear: () => void;
}

export const CustomerFilters = ({
  ordersMinMonth,
  ordersMaxMonth,
  saleType,
  countryId,
  customerOrigins,
  updateFilters,
  onClear,
}: CustomerFiltersProps) => {
  const { t } = useTranslation('marketingModule');

  const activeFiltersCount = useMemo(() => {
    let count = 0;
    if (ordersMinMonth !== null || ordersMaxMonth !== null) count++;
    if (saleType) count++;
    if (countryId !== null) count++;
    if (customerOrigins?.length > 0) count++;
    return count;
  }, [ordersMinMonth, ordersMaxMonth, saleType, countryId, customerOrigins]);

  return (
    <FiltersDropdown
      title={t('filters.title', 'Filtros')}
      activeFiltersCount={activeFiltersCount}
      triggerTestId="marketing-customer-filters-toggle"
      dropdownContentClassName="sm:min-w-[520px] sm:max-w-[560px] p-4 bg-body-bg text-foreground border border-card-border max-h-[min(90vh,720px)] overflow-hidden flex flex-col"
    >
      <CustomerFiltersPanel
        ordersMinMonth={ordersMinMonth}
        ordersMaxMonth={ordersMaxMonth}
        saleType={saleType}
        countryId={countryId}
        customerOrigins={customerOrigins}
        activeFiltersCount={activeFiltersCount}
        updateFilters={updateFilters}
        onClear={onClear}
      />
    </FiltersDropdown>
  );
};
